// const Host = "http://127.0.0.1:8000/api";
const Host = "https://booksmmapi.rentchicken.net/api";
export const api_Routes = {
  Auth: {
    login: `${Host}/admin/login`,
  },
  Groups: {
    PanelView: `${Host}/group/panels`,
    TelegramView: `${Host}/TelegramGroups`,
    TelegramGetOne: `${Host}/getTelegramGroupsByid/`,
    TelegramAdd: `${Host}/AddTelegramGroups`,
    TelegramEdit: `${Host}/updateTelegramGroups/`,
    TelegramDelete: `${Host}/deleteTelegramGroups/`,
    Whatsapp: {
      View: `${Host}/WhatsappGroups`,
      GetOne: `${Host}/getWhatsappGroupsByid/`,
      Add: `${Host}/AddWhatsappGroups`,
      Edit: `${Host}/updateWhatsappGroups/`,
      Delete: `${Host}/deleteWhatsappGroups/`,
    },
    Skype: {
      View: `${Host}/getAllGroupSkype`,
      GetOne: `${Host}/getGroupSkypeById/`,
      Add: `${Host}/addSkypeGroups`,
      Edit: `${Host}/updateSkypeGroups/`,
      Delete: `${Host}/deleteSkypeGroups/`,
    },
  },
  ShopAds: {
    View: `${Host}/admin/ourService`,
    Add: `${Host}/admin/ourService`,
    Edit: `${Host}/admin/ourService`,
    GetOne: `${Host}/admin/ourService`,
    Delete: `${Host}/admin`,
  },
  Type: {
    Add: `${Host}/admin/type`,
    Edit: `${Host}/admin/type`,
    Delete: `${Host}/admin`,
  },
  PinsAdvertising: {
    View: `${Host}/admin/pins`,
    UpdateStatus: `${Host}/admin/pins/changeStatus/`,
    Edit: `${Host}/admin/pin/editPin/`,
    GetOne: `${Host}/admin/pin/`,
  },
  BannersAdvertising: {
    View: `${Host}/admin/banner`,
    UpdateStatus: `${Host}/admin/banner/changeStatus/`,
    Edit: `${Host}/admin/banner/editBanner/`,
    GetOne: `${Host}/admin/banner/`,
  },
  TopResultAdvertising: {
    View: `${Host}/admin/TopResult`,
    UpdateStatus: `${Host}/admin/TopResult/changeStatus/`,
  },
  TicketsAdvertising: {
    View: `${Host}/admin/ticketAds`,
    UpdateStatus: `${Host}/admin/ticketAds/changeStatus/`,
    UpdateCountTicket: `${Host}/admin/ticketAds/change_count_ticket_send/`,
    Edit: `${Host}/admin/EditTicketAds/`,
    GetOne: `${Host}/admin/ticketAds/`,
  },
  Trust: {
    Edit: `${Host}/admin/trusts/`,
  },
  Orders: {
    View: `${Host}/admin/Order`,
    ViewByOffers: `${Host}/admin/OrderOffer`,
    Add: `${Host}/admin/Order`,
    GetOne: `${Host}/admin/getOrderById/`,
    AddOfferOrder: `${Host}/admin/CreateOfferOrder`,
    Edit: `${Host}/admin/Order/`,
  },
  Countries: {
    View: `${Host}/countries`,
  },
  Users: {
    View: `${Host}/admin/users`,
    ViewAll: `${Host}/admin/AllUsers`,
    Edit: `${Host}/admin/ediUser/`,
    Add: `${Host}/admin/addUser`,
    ViewUserDetails: `${Host}/admin/user/`,
  },
  Employees: {
    View: `${Host}/admin/employees`,
    GetOne: `${Host}/admin/employee/`,
    Edit: `${Host}/admin/employee/`,
    Add: `${Host}/admin/employee`,
    Delete: `${Host}/admin/employee/`,
  },
  Permissions: {
    View: `${Host}/admin/permissions`,
  },
  Panels: {
    View: `${Host}/admin/panels`,
    GetOne: `${Host}/admin/panel/`,
    Edit: `${Host}/admin/panel/`,
    Add: `${Host}/admin/panel`,
    Delete: `${Host}/admin/panel/`,
    GetServices: `${Host}/admin/GetServices/`,
    screenshots: `${Host}/admin/take-screenshot/`,
    log: `${Host}/admin/panel/log`,
  },
  Categories: {
    View: `${Host}/admin/categories`,
    ViewAll: `${Host}/admin/categories/all`,
    GetOne: `${Host}/admin/categories/`,
    Edit: `${Host}/admin/categories/`,
    Add: `${Host}/admin/categories`,
    Delete: `${Host}/admin/categories/`,
  },
  SubCategories: {
    View: `${Host}/admin/subcategories`,
    GetOne: `${Host}/admin/subcategories/`,
    Edit: `${Host}/admin/subcategories/`,
    Add: `${Host}/admin/subcategories`,
    Delete: `${Host}/admin/subcategories/`,
  },
  Support: {
    View: `${Host}/admin/TicketsSupport`,
    viewTicket: `${Host}/admin/MessageByTicket/`,
    Replay: `${Host}/admin/CreateMessage`,
    UpdateStatus: `${Host}/admin/UpdateChatStatus`,
  },
  Services: {
    View: `${Host}/admin/ourService`,
    ViewTicketsFilter: `${Host}/admin/ticketAds/filterServices`,
  },
  Offers: {
    View: `${Host}/admin/getAllOffers`,
    GetOne: `${Host}/admin/getOfferById/`,
    Edit: `${Host}/admin/updateOffers/`,
    Add: `${Host}/admin/createOffers`,
    Delete: `${Host}/admin/deleteOfferById/`,
  },
  dashboard: {
    getStatistics: `${Host}/admin/getDashboardStats`,
  },
  Review: {
    view: `${Host}/admin/panelsReviwes`,
    Delete: `${Host}/admin/deleteReview/`,
    Verify: `${Host}/admin/verifyReview/`,
  },
  Notifications: {
    View: `${Host}/admin/getNotifications`,
    Read: `${Host}/admin/readNoification`,
    ReadAll: `${Host}/admin/readAllNoifications`,
  },
  Faqs: {
    View: `${Host}/faqs`,
    GetOne: `${Host}/faqs`,
    Add: `${Host}/admin/faqs`,
    Edit: `${Host}/admin/updateFaqs/`,
    Delete: `${Host}/admin/faqs/`,
  },
  Marketers: {
    View: `${Host}/marketers`,
    GetOne: `${Host}/marketers`,
    Add: `${Host}/admin/marketers`,
    Edit: `${Host}/admin/updateMarketers/`,
    Delete: `${Host}/admin/marketers/`,
  },
  Settings: {
    View: `${Host}/admin/settings`,
    Edit: `${Host}/admin/settings`,
  },
  PaymentMethods: {
    get: `${Host}/getpaymentmethods`,
  },
  UpdatedPanels: {
    View: `${Host}/admin/updated-panels`,
    Process: `${Host}/admin/updated-panels`,
  },
};
